import { DocumentCivilStatusCivilUnionUploadCrumbs } from 'civil-status/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormDocumentCivilUnionUploadNew from 'civil-status/components/upload-document-civil-union-form';
import { transformUploadCivilUnionNewPage } from 'civil-status/utils/transform-upload-new-act';
import { DocumentCivilUnionUploadFormVM } from 'civil-status/view-models/document-birth-form';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

export default function DocumentCivilUnionUploadNewPage(): React.ReactElement {
  const insert = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/atti-unione-civile-sima/caricamento-atto-unione-civile/inesistente`,
    {
      options: { method: 'POST', loading: true, errorCatching: true },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: DocumentCivilUnionUploadFormVM | undefined) => {
      const data = transformUploadCivilUnionNewPage(formValues);
      (
        insert({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/unione-civile');
      });
    },
    [insert, navigate]
  );

  return (
    <>
      <Breadcrumbs items={DocumentCivilStatusCivilUnionUploadCrumbs} base="stato-civile" />
      <FormDocumentCivilUnionUploadNew
        title="Caricamento Nuovo Atto"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/stato-civile/unione-civile');
        }}
      />
    </>
  );
}

DocumentCivilUnionUploadNewPage.displayName = 'home page component';
